// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1CKZL","Wrapper":"Footer_Wrapper__X7nZD","Logo":"Footer_Logo__3MA04"};